import React, { useEffect, useRef } from 'react';

const XCursor = () => {
  const ref = useRef(null);
  const pos = useRef({ x: -100, y: -100 });
  const target = useRef({ x: -100, y: -100 });
  const raf = useRef(null);

  useEffect(() => {
    // Only enable on fine pointers (desktop)
    if (typeof window === 'undefined' || !window.matchMedia('(pointer: fine)').matches) return;
    const el = ref.current;
    if (!el) return;

    const onMove = (e) => {
      target.current = { x: e.clientX, y: e.clientY };
      const interactive = e.target.closest('a, button, [role="button"], .cursor-pointer, .group, input, textarea');
      el.classList.toggle('is-hover', !!interactive && !e.target.closest('input, textarea'));
    };
    const onDown = () => el.classList.add('is-down');
    const onUp = () => el.classList.remove('is-down');
    const onLeave = () => { el.style.opacity = '0'; };
    const onEnter = () => { el.style.opacity = '1'; };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mousedown', onDown);
    window.addEventListener('mouseup', onUp);
    document.addEventListener('mouseleave', onLeave);
    document.addEventListener('mouseenter', onEnter);

    const tick = () => {
      pos.current.x += (target.current.x - pos.current.x) * 0.42;
      pos.current.y += (target.current.y - pos.current.y) * 0.42;
      el.style.transform = `translate(${pos.current.x}px, ${pos.current.y}px)`;
      raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mousedown', onDown);
      window.removeEventListener('mouseup', onUp);
      document.removeEventListener('mouseleave', onLeave);
      document.removeEventListener('mouseenter', onEnter);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return (
    <div ref={ref} className="x-cursor" aria-hidden="true">
      <img src="/favicon-x.png" alt="" className="x-cursor-inner" />
    </div>
  );
};

export default XCursor;
